"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var UserAndSiteSettingsContext_1 = require("../../utils/UserAndSiteSettingsContext");
var UrlSortProvider_1 = require("../UrlSortProvider");
exports.OwnersDefaultDirections = (_a = {},
    _a[globalTypes_1.TableauUserOrderField.ID] = globalTypes_1.OrderDirection.ASC,
    _a[globalTypes_1.TableauUserOrderField.NAME] = globalTypes_1.OrderDirection.ASC,
    _a);
function OwnersGridSortProvider(props) {
    var areUsersVisible = React.useContext(UserAndSiteSettingsContext_1.UserAndSiteSettingsContext).areUsersVisible;
    var ownersDefaultSortField = areUsersVisible ? globalTypes_1.TableauUserOrderField.NAME : globalTypes_1.TableauUserOrderField.ID;
    var _a = globalTypes_1.TableauUserOrderField.NAME, _ = exports.OwnersDefaultDirections[_a], validFieldsForHiddenUser = __rest(exports.OwnersDefaultDirections, [typeof _a === "symbol" ? _a : _a + ""]);
    var validFields = areUsersVisible ? exports.OwnersDefaultDirections
        : validFieldsForHiddenUser;
    return (React.createElement(UrlSortProvider_1.UrlSortProvider, { validOrderFieldsWithDefaultDirections: validFields, defaultField: ownersDefaultSortField }, props.children));
}
exports.OwnersGridSortProvider = OwnersGridSortProvider;
//# sourceMappingURL=OwnersGridSortProvider.js.map